import { render, staticRenderFns } from "./GLListOrder.vue?vue&type=template&id=136331d3&scoped=true"
import script from "./GLListOrder.vue?vue&type=script&lang=js"
export * from "./GLListOrder.vue?vue&type=script&lang=js"
import style0 from "./GLListOrder.vue?vue&type=style&index=0&id=136331d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136331d3",
  null
  
)

export default component.exports